import type { RouteObject } from "react-router-dom";

export const popupAnalyticsRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Popup analytics" },
    async lazy() {
      const { Page } = await import("../../app/page");
      return { element: <Page hidePadding={() => true} /> };
    },
    children: [
      {
        index: true,
        async lazy() {
          const { PopupAnalyticsPage } = await import("./popup-analytics-page");
          return { Component: PopupAnalyticsPage };
        },
      },
    ],
  },
];
